import { Button, Card, CardBody, CardHeader } from "reactstrap"
import styled from "styled-components"


export const StyledMainCard = styled(Card).attrs(() => ({
    className: "msg-card  shadow border-0"
}))``

export const StyledCardHeader = styled(CardHeader).attrs(() => ({
    className: "msg_head"
}))`
background: ${props => props.background};
  font-family: 'Lato', sans-serif;
  font-size: 1.3em;
`

export const HeaderDiv = styled.div.attrs(() => ({
    className: "d-flex bd-highlight"
}))`color: white;
align-items: center;`

export const StyledCardBody = styled(CardBody).attrs(() => ({
    className: "msg_card_body", id: "chat-container"
}))`
height: 100%;
overflow: auto;
display: flex;
flex-direction: column-reverse;
scroll-behavior: smooth;
`
export const StyledScrollDiv = styled.div.attrs(() => ({
    // className: "msg_card_body",
}))`
height: 100%;
overflow: auto;
display: flex;
flex-direction: column-reverse;
scroll-behavior: smooth;
`


export const StyledButton = styled.button.attrs(() => ({

}))`
width: 50px;
height: 50px;
padding: 0;

`

export const StyledSendIcon = styled.i.attrs(() => ({
    className: "icon-send text-black"
}))`
font-size: 2em;

`
export const StyledDiv = styled.div.attrs(() => ({
    className: "conversation-list mt-[28px] "
}))`
`
export const StyledPara = styled.p.attrs(() => ({
    className: "text-center mb-1 text-sm font-extrabold"
}))`

`

export const StyledDiv1 = styled.p.attrs(() => ({
    className: "d-flex justify-content-end my-[38px]"
}))`

`
export const StyledDiv2 = styled.p.attrs(() => ({
    className: "min-w-[80px] py-2 px-4 lg:px-4 lg:py-3 shadow-xl  text-dark text-sm position-relative bg-[#21C1E0]  bg-opacity-50  rounded-l-full rounded-tr-full xl:text-lg break-words whitespace-normal"
}))`

`

export const StyledDiv3 = styled.p.attrs(() => ({
    className: "d-flex justify-content-start my-[28px]"
}))`

`

export const StyledDiv4 = styled.p.attrs(() => ({
    className: " py-2 px-3 px-lg-4 py-lg-3 shadow-xl text-center text-dark text-sm position-relative rounded-r-full rounded-tl-full min-w-[80px] xl:text-lg bg-white break-words whitespace-normal"
}))`

`
export const StyledDiv5 = styled.p.attrs(() => ({
    className: " py-2 px-3 px-lg-4 py-lg-3 shadow-xl text-center text-dark text-sm position-relative rounded-lg min-w-15 xl:text-lg bg-white break-words whitespace-normal"
}))`

`